import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import moment from "moment";

import { SearchOutlined } from "@ant-design/icons";

import { Table, Input, Button, Popconfirm, Tag } from "antd";
import Highlighter from "react-highlight-words";

import Breadcrumb from "../../components/Breadcrumb";
import ExportCSV from "../../components/Common/ExportCSV";

// const data = this.props.api.userGetData;

class Hmg extends Component {
  state = {
    searchText: "",
    searchedColumn: "",
    loading: false,
    visible: false,
    createModalVisible: false,
    updateModalVisible: false,
    updateInitialValue: null,
  };
  async componentDidMount() {
    if (!this.props.api.hmgMainGetData) {
      await this.props.hmgMainGet();
    }
    // if (!this.props.api.indexesGetData) {
    //   await this.props.indexesGet();
    // }
  }

  getColumnSearchProps = (dataIndex, type, isSearchIndexs) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          // placeholder={`Search ${dataIndex}`}
          placeholder="Search"
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{
            width: 90,
            marginRight: 8,
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      if (type == "array") {
        if (record[dataIndex]) {
          let rValue = false;
          record[dataIndex].forEach((d) => {
            if (
              d.project_name
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
            ) {
              rValue = true;
            }
          });
          return rValue;
          // return record.hotels.hotel_name.toString().toLowerCase().includes(value.toLowerCase())
        } else {
          return false;
        }
      } else {
        if (record[dataIndex]) {
          return record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        } else {
          return false;
        }
      }
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex && text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    this.setState({ searchText: "" });
  };

  createModalShow = () => {
    this.setState({ createModalVisible: true });
  };

  createModalCancel = () => {
    this.setState({ createModalVisible: false });
  };

  createModalCreate = () => {
    const { form } = this.createModalFormRef.props;
    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        return;
      }
      // const qqqq = await this.props.userCreate(values);

      if (await this.props.hmgCreate(values)) {
        form.resetFields();
        await this.props.hmgGet();
        this.setState({ createModalVisible: false });
      }
    });
  };

  createModalFormRefSaveFormRef = (formRef) => {
    this.createModalFormRef = formRef;
  };

  handleEdit = (data) => {
    this.setState({ updateModalVisible: true, updateInitialValue: data });
  };

  updateModalShow = (data) => {
    this.setState({ updateModalVisible: true, updateInitialValue: data });
  };

  updateModalCancel = () => {
    const { form } = this.updateModalFormRef.props;
    form.resetFields();
    this.setState({ updateModalVisible: false, updateInitialValue: null });
  };

  updateModalCreate = () => {
    const { form } = this.updateModalFormRef.props;
    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        return;
      }
      // const qqqq = await this.props.userCreate(values);

      if (await this.props.hmgUpdate(values)) {
        form.resetFields();
        await this.props.hmgGet();
        this.setState({ updateModalVisible: false });
      }
    });
  };

  updateModalFormRefSaveFormRef = (formRef) => {
    this.updateModalFormRef = formRef;
  };

  hmgDelete = async (value) => {
    console.log(value);

    if (await this.props.deleteItem({ type: "hmg", _id: value })) {
      await this.props.hmgMainGet();
    }
  };
  getUpdatedExcelBuffer = (data) => {
    const newData = data.map((i) => {
      const newData2 = { ...i };
      newData2.projects = i.projects.map((k) => {
        return (k.project_name);
      }).join();
      newData2.create_at = i.create_at ? moment(i.create_at).local().format("YYYY-MM-DD HH:mm:ss") : null;
      newData2.update_at = i.update_at ? moment(i.update_at).local().format("YYYY-MM-DD HH:mm:ss") : null;
      return newData2;
    });
    return newData;
  };

  render() {
    let columns = [
      {
        title: "HMG Name",
        dataIndex: "hmg_name",
        key: "hmg_name",
        fixed: "left",
        width: "200px",
        ...this.getColumnSearchProps("hmg_name"),
        sorter: (a, b) =>
          a.hmg_name ? a.hmg_name.localeCompare(b.hmg_name) : null,
      },
      {
        title: "ID",
        dataIndex: "_id",
        key: "_id",
        width: "250px",
        ...this.getColumnSearchProps("_id"),
        sorter: (a, b) => (a._id ? a._id.localeCompare(b._id) : null),
      },

      {
        title: "Projects",
        dataIndex: "projects",
        key: "hotels",
        width: "400px",
        ...this.getColumnSearchProps("projects", "array", ["project_name"]),
        render: (projects) => (
          <span>
            {projects.map((project) => (
              <div key={project._id}>{project.project_name}</div>
            ))}
          </span>
        ),
      },
      {
        title: "Entity ID",
        dataIndex: "is_entityid",
        key: "is_entityid",
        width: "150px",
        ...this.getColumnSearchProps("is_entityid"),
        sorter: (a, b) => {
          a = a.is_entityid || 0;
          b = b.is_entityid || 0;
          return a - b;
        },
      },

      // {
      //   title: "IS Admin Username",
      //   dataIndex: "is_admin_username",
      //   key: "is_admin_username",
      //   width: "220px",
      //   ...this.getColumnSearchProps("is_admin_username"),
      //   sorter: (a, b) =>
      //     a.is_admin_username
      //       ? a.is_admin_username.localeCompare(b.is_admin_username)
      //       : null,
      // },
      // {
      //   title: "IS Admin Password",
      //   dataIndex: "is_admin_password",
      //   key: "is_admin_password",
      //   width: "220px",
      //   ...this.getColumnSearchProps("is_admin_password"),
      //   sorter: (a, b) =>
      //     a.is_admin_password
      //       ? a.is_admin_password.localeCompare(b.is_admin_password)
      //       : null,
      // },

      {
        title: "MYP HMG ID",
        dataIndex: "myp_id",
        key: "myp_id",
        width: "200px",
        ...this.getColumnSearchProps("myp_id"),
        sorter: (a, b) => {
          a = a.myp_id || 0;
          b = b.myp_id || 0;
          return a - b;
        },
      },
      {
        title: "MDO Mgmt Group Email",
        dataIndex: "mdo_mgmtgroupemail",
        key: "mdo_mgmtgroupemail",
        width: "250px",
        ...this.getColumnSearchProps("mdo_mgmtgroupemail"),
        sorter: (a, b) =>
          a.mdo_mgmtgroupemail
            ? a.mdo_mgmtgroupemail.localeCompare(b.mdo_mgmtgroupemail)
            : null,
      },
      {
        title: "MDO Mgmt Group Email Password",
        dataIndex: "mdo_mgmtgroupemailpassword",
        key: "mdo_mgmtgroupemailpassword",
        width: "300px",
        ...this.getColumnSearchProps("mdo_mgmtgroupemailpassword"),
      },
      {
        title: "V2.2 HMG",
        dataIndex: "hmg_22",
        key: "hmg_22",
        width: "200px",
        render: (text) => {
          if (text) {
            return <Tag color="blue">Enable</Tag>;
          } else {
            return <Tag color="red">Disable</Tag>;
          }
        },
        sorter: (a, b) => {
          a = a.hmg_22 ? 0 : 1;
          b = b.hmg_22 ? 0 : 1;
          return a - b;
        },
      },

      {
        title: "Name",
        dataIndex: "corp_contact_name",
        key: "corp_contact_name",
        width: "250px",
        ...this.getColumnSearchProps("corp_contact_name"),
        sorter: (a, b) =>
          a.corp_contact_name
            ? a.corp_contact_name.localeCompare(b.corp_contact_name)
            : null,
      },
      {
        title: "Position Title",
        dataIndex: "corp_position_title",
        key: "corp_position_title",
        width: "250px",
        ...this.getColumnSearchProps("corp_position_title"),
        sorter: (a, b) =>
          a.corp_position_title
            ? a.corp_position_title.localeCompare(b.corp_position_title)
            : null,
      },
      {
        title: "Office Phone",
        dataIndex: "corp_office_phone",
        key: "corp_office_phone",
        width: "250px",
        ...this.getColumnSearchProps("corp_office_phone"),
        sorter: (a, b) =>
          a.corp_office_phone
            ? a.corp_office_phone.localeCompare(b.corp_office_phone)
            : null,
      },
      {
        title: "Work Cell",
        dataIndex: "corp_work_cell",
        key: "corp_work_cell",
        width: "250px",
        ...this.getColumnSearchProps("corp_work_cell"),
        sorter: (a, b) =>
          a.corp_work_cell
            ? a.corp_work_cell.localeCompare(b.corp_work_cell)
            : null,
      },
      {
        title: "Email",
        dataIndex: "corp_email",
        key: "corp_email",
        width: "250px",
        ...this.getColumnSearchProps("corp_email"),
        sorter: (a, b) =>
          a.corp_email ? a.corp_email.localeCompare(b.corp_email) : null,
      },

      {
        title: "Address",
        dataIndex: "corp_address",
        key: "corp_address",
        width: "250px",
        ...this.getColumnSearchProps("corp_address"),
        sorter: (a, b) =>
          a.corp_address ? a.corp_address.localeCompare(b.corp_address) : null,
      },
      {
        title: "City",
        dataIndex: "corp_city",
        key: "corp_city",
        width: "250px",
        ...this.getColumnSearchProps("corp_city"),
        sorter: (a, b) =>
          a.corp_city ? a.corp_city.localeCompare(b.corp_city) : null,
      },
      {
        title: "Zip",
        dataIndex: "corp_zip",
        key: "corp_zip",
        width: "250px",
        ...this.getColumnSearchProps("corp_zip"),
        sorter: (a, b) =>
          a.corp_zip ? a.corp_zip.localeCompare(b.corp_zip) : null,
      },
      {
        title: "Country",
        dataIndex: "country",
        key: "country",
        width: "250px",
        ...this.getColumnSearchProps("country"),
        sorter: (a, b) =>
          a.country ? a.country.localeCompare(b.country) : null,
      },
      {
        title: "State",
        dataIndex: "state",
        key: "state",
        width: "250px",
        ...this.getColumnSearchProps("state"),
        sorter: (a, b) => (a.state ? a.state.localeCompare(b.state) : null),
      },
      // {
      //   title: "Hotels On Portfolio",
      //   dataIndex: "hotels_on_portfolio",
      //   key: "hotels_on_portfolio",
      //   width: "250px",
      //   ...this.getColumnSearchProps("hotels_on_portfolio"),
      //   sorter: (a, b) => a.hotels_on_portfolio ? a.hotels_on_portfolio.localeCompare(b.hotels_on_portfolio) : null
      // },
      // {
      //   title: "Hotels On Solution",
      //   dataIndex: "hotels_on_solution",
      //   key: "hotels_on_solution",
      //   width: "250px",
      //   ...this.getColumnSearchProps("hotels_on_solution"),
      //   sorter: (a, b) => a.hotels_on_solution ? a.hotels_on_solution.localeCompare(b.hotels_on_solution) : null
      // },

      // {
      //   title: "Offboard",
      //   dataIndex: "offboard",
      //   key: "offboard",
      //   width: "200px",
      //   ...this.getColumnSearchProps("offboard")
      // },
      // {
      //   title: "Description",
      //   dataIndex: "r_description",
      //   key: "r_description",
      //   width: "250px",
      //   ...this.getColumnSearchProps("r_description")
      // },
      // {
      //   title: "Revenue",
      //   dataIndex: "revenue",
      //   key: "revenue",
      //   width: "250px",
      //   ...this.getColumnSearchProps("revenue")
      // },
      // {
      //   title: "Special Notes",
      //   dataIndex: "special_notes",
      //   key: "special_notes",
      //   width: "250px",
      //   ...this.getColumnSearchProps("special_notes")
      // },
      // {
      //   title: "Teamwork Project ID",
      //   dataIndex: "teamwork_project_id",
      //   key: "teamwork_project_id",
      //   width: "200px",
      //   ...this.getColumnSearchProps("teamwork_project_id")
      // },
      // {
      //   title: "Teamwork Tasklist ID",
      //   dataIndex: "teamwork_tasklist_id",
      //   key: "teamwork_tasklist_id",
      //   width: "200px",
      //   ...this.getColumnSearchProps("teamwork_tasklist_id")
      // },

      {
        title: "Smart Scan",
        dataIndex: "smart_scan_type",
        key: "smart_scan_type",
        width: "200px",
        render: (text) => {
          if (text === "1") {
            return (
              <Tag
                color="blue"
                style={{ minWidth: "70px", textAlign: "center" }}
              >
                Yes
              </Tag>
            );
          } else if (text === "0") {
            return (
              <Tag
                color="red"
                style={{ minWidth: "70px", textAlign: "center" }}
              >
                No
              </Tag>
            );
          } else {
            return (
              <Tag
                color="red"
                style={{ minWidth: "70px", textAlign: "center" }}
              >
                No
              </Tag>
            );
          }
        },
        sorter: (a, b) => {
          a = a.smart_scan_type ? a.smart_scan_type : "2";
          b = b.smart_scan_type ? b.smart_scan_type : "2";
          return a.localeCompare(b);
        },
      },

      {
        title: "Split Reports By Sub Header Type",
        dataIndex: "split_by_sub_header",
        key: "split_by_sub_header",
        width: "300px",
        render: (text) => {
          if (text === "1") {
            return (
              <Tag
                color="blue"
                style={{ minWidth: "70px", textAlign: "center" }}
              >
                Yes
              </Tag>
            );
          } else if (text === "0") {
            return (
              <Tag
                color="red"
                style={{ minWidth: "70px", textAlign: "center" }}
              >
                No
              </Tag>
            );
          } else {
            return (
              <Tag
                color="red"
                style={{ minWidth: "70px", textAlign: "center" }}
              >
                No
              </Tag>
            );
          }
        },
        sorter: (a, b) => {
          a = a.split_by_sub_header ? a.split_by_sub_header : "2";
          b = b.split_by_sub_header ? b.split_by_sub_header : "2";
          return a.localeCompare(b);
        },
      },

      {
        title: "Created by",
        dataIndex: "create_by",
        key: "create_by",
        width: "200px",
        ...this.getColumnSearchProps("create_by"),
      },
      {
        title: "Created at",
        dataIndex: "create_at",
        key: "create_at",
        width: "200px",
        ...this.getColumnSearchProps("create_at"),
        render: (text) => (
          <span>
            {text ? moment(text).local().format("YYYY-MM-DD HH:mm:ss") : null}
          </span>
        ),
      },
      {
        title: "Updated by",
        dataIndex: "update_by",
        key: "update_by",
        width: "200px",
        ...this.getColumnSearchProps("update_by"),
      },
      {
        title: "Updated at",
        dataIndex: "update_at",
        key: "update_at",
        width: "200px",
        ...this.getColumnSearchProps("update_at"),
        render: (text) => (
          <span>
            {text ? moment(text).local().format("YYYY-MM-DD HH:mm:ss") : null}
          </span>
        ),
      },

      // {
      //   title: "Action",
      //   dataIndex: "action",
      //   fixed: "right",
      //   width: "100px",
      //   render: (text, record) => (
      //     <Popconfirm
      //       title="Sure to edit?"
      //       onConfirm={() => this.updateModalShow(record)}
      //     >
      //       <a href="/#">Edit</a>
      //     </Popconfirm>
      //   )
      // }
    ];

    if (this.props.api.permission.sm_hmg_delete) {
      columns.push({
        title: "Action",
        dataIndex: "action",
        // fixed: "right",
        width: "100px",
        render: (text, record) => (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => this.hmgDelete(record._id)}
          >
            <Button
              type="default"
              danger
              size="small"
              style={{ paddingLeft: "5px", paddingRight: "5px" }}
            >
              Delete
            </Button>
          </Popconfirm>
        ),
      });
    }

    let tableHeight = 500;
    if (window.innerWidth > 700) {
      tableHeight = window.innerHeight - 300;
    }

    return (
      <div>
        <div className="container_aa">
          <h3>HMG Manager</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              { path: "hmg-manager", breadcrumbName: "HMG Manager" },
            ]}
          />
        </div>

        <div className="container_ab">
          <div className="container_style_1 user_manager">
            {/* <div className="container_style_1_a">
              <Button type="primary" onClick={this.createModalShow}>
                Create HMG
              </Button>
            </div> */}
            <div className="container_style_1_b" style={{ width: "100%" }}>
              {this.props.api.hmgMainGetData ? (
                <div className="is_table_3">
                  <ExportCSV
                    csvData={this.getUpdatedExcelBuffer(this.props.api.hmgMainGetData.data)}
                    fileName={"hmg-manager"}
                    columnNames={columns}
                  />
                  <Table
                    className={"sm-custom-column-header"}
                    columns={columns}
                    scroll={{ x: 5670, y: tableHeight }}
                    dataSource={this.props.api.hmgMainGetData.data}
                    rowKey="_id"
                  />
                </div>
              ) : null}
              {/* {this.props.api.indexesGetData ? (
                <CreateForm
                  wrappedComponentRef={this.createModalFormRefSaveFormRef}
                  visible={this.state.createModalVisible}
                  onCancel={this.createModalCancel}
                  onCreate={this.createModalCreate}
                  indexesGetData={this.props.api.indexesGetData.data}
                />
              ) : null} */}
              {/* {this.props.api.indexesGetData ? (
                <UpdateForm
                  wrappedComponentRef={this.updateModalFormRefSaveFormRef}
                  visible={this.state.updateModalVisible}
                  onCancel={this.updateModalCancel}
                  onCreate={this.updateModalCreate}
                  updateInitialValue={this.state.updateInitialValue}
                  indexesGetData={this.props.api.indexesGetData.data}
                />
              ) : null} */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hmgGet: () => dispatch(actions.hmgGet()),
  hmgMainGet: () => dispatch(actions.hmgMainGet()),
  indexesGet: () => dispatch(actions.indexesGet()),
  hmgCreate: (data) => dispatch(actions.hmgCreate(data)),
  hmgUpdate: (data) => dispatch(actions.hmgUpdate(data)),
  deleteItem: (data) => dispatch(actions.deleteItem(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Hmg);
